<template>
  <div class="wt-media-filtering-search-tags">
    <transition name="-transition-height">
      <wt-carousel-gallery
        v-if="shouldShowTags"
        :bus="this"
        class="wt2-media-filtering-carousel-gallery"
      >
        <ul class="wt2-media-filtering-tags">
          <div
            v-for="tag in normalizeTags"
            :key="tag.name"
            @select="onSelect"
            @unselect="unSelect"
            :values="tag.values"
            :bg-color-class="tag.bgColorClass"
            :is="tag.component"
          ></div>
        </ul>
      </wt-carousel-gallery>
    </transition>
  </div>
</template>

<script>
import app from 'app';
const tagsMixin = {
  computed: {
    displayFirstValueLowerCase() {
      return (
        _.isArray(this.values) &&
        _.isString(this.values[0]) &&
        this.values[0].toLowerCase()
      );
    },
  },
};

const unSelectedTag = app.Vue.extend({
  // language=Vue
  template: `
<li class="-un-selected-tag"
    :class="bgColorClass"
    @click="$emit('select', values, $event)">
   <span class="wt2-text-n wt2-color-negative">
     {{displayFirstValueLowerCase}}
   </span>
</li>       
       `.normalizeSpace(),
  name: 'un-selected-tag',
  mixins: [tagsMixin],
  props: {
    values: {
      type: Array,
      required: true,
      default: () => [],
    },

    bgColorClass: {
      type: String,
      required: true,
    },
  },
});

const selectedTag = app.Vue.extend({
  // language=Vue
  template: `
<li class="-selected-tag">
   <span class="wt2-text-n">
     {{displayFirstValueLowerCase}}
   </span>
   <wt-close 
       @click.native="$emit('unselect', values, $event)">
   </wt-close>
</li>       
       `.normalizeSpace(),
  name: 'selected-tag',
  mixins: [tagsMixin],
  props: {
    values: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
});
export default {
  // language=Vue

  name: 'wt-media-filtering-search-tags',

  components: {
    unSelectedTag,
    selectedTag,
  },

  props: {
    rawTags: {
      type: Array,
      default: () => [],
    },

    selectedTags: {
      type: Array,
      default: () => [],
    },

    bgColorsClasses: {
      type: Array,
      default: () => [
        '-first-bg-color',
        // '-second-bg-color',
        // '-third-bg-color'
      ],
    },

    showTags: {
      type: Boolean,
      default: true,
    },

    disabled: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      currColorIndex: 0,
    };
  },

  computed: {
    normalizeTags() {
      const selectedTags = _.isArray(this.selectedTags)
        ? this.selectedTags
        : [];
      const rawTags = _.isArray(this.rawTags) ? this.rawTags : [];
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.currColorIndex = 0;

      return [
        ...this.processSelectedTags(selectedTags),
        ...this.processRawTags(rawTags),
      ];
    },

    shouldShowTags() {
      return this.showTags && this.normalizeTags.length;
    },
  },

  watch: {
    normalizeTags() {
      this.$emit('CAROUSEL_GALLERY_RESET');
    },
  },

  methods: {
    processRawTags(tags) {
      return _.reduce(
        tags,
        (acc, curValue) => {
          this.pushUnSelected(acc, curValue);
          return acc;
        },
        []
      );
    },

    processSelectedTags(selectedTags) {
      return _.map(selectedTags, (t) => {
        return {
          values: t,
          component: selectedTag,
        };
      });
    },

    pushUnSelected(acc, curValue) {
      // curValue keywords can be one cluster or each one his own cluster
      _.each(curValue.keywords, (keyword, index) => {
        if (
          _.isObject(keyword) &&
          _.isArray(keyword.values) &&
          keyword.values.length
        ) {
          const isSelected = _.some(this.selectedTags, (arr) =>
            _.every(arr, (tag) => keyword.values.includes(tag))
          );

          // only if keyword is not selected, add it to list
          if (!isSelected) {
            acc.push({
              values: keyword.values,
              component: unSelectedTag,
              bgColorClass: this.bgColorsClasses[this.currColorIndex],
            });

            const noOneClusterType = _.isNull(curValue.type);
            const lastKeyword = index + 1 !== curValue.keywords.length;

            // if curValue has no type it mean's every keyword
            // should be in his own cluster except the last keyword
            // cause it will update outside the each loop
            if (noOneClusterType && lastKeyword) {
              this.updateCurColorIndex();
            }
          }
        }
      });

      this.updateCurColorIndex();
    },

    updateCurColorIndex() {
      this.currColorIndex =
        this.currColorIndex + 1 === this.bgColorsClasses.length
          ? 0
          : this.currColorIndex + 1;
    },

    allowEvent(values, e) {
      return (
        e &&
        !e.defaultPrevented &&
        !this.disabled &&
        values &&
        _.isArray(values) &&
        values.length
      );
    },

    onSelect(values, e) {
      if (this.allowEvent(values, e)) {
        const newArr = this.selectedTags.concat([values]);
        this.$emit('change', [...new Set(newArr)]);
      }
    },

    unSelect(values, e) {
      if (this.allowEvent(values, e)) {
        const newArr = _.filter(
          this.selectedTags,
          (arr) => !_.every(arr, (tag) => _.includes(values, tag))
        );
        this.$emit('change', newArr);
      }
    },
  },
};
</script>
